import * as React from 'react';
import Spacing from '@able/react/dist/Spacing';
import StaticData, { StaticDataGroup } from 'ted-ui/build/StaticData';
import { ProductSheetLocationDetails } from '../../../../../../config/order-tracker-new-common/constants';
import { ProductDetailsSection } from '../product-details-section';
import { validateProductFields } from '@applications/order-tracker/config/order-tracker-new-common/order-products-utils';
import { useResize } from 'ted-ui/build/util';

const LocationAndContactDetails = ({
  siteName,
  siteRawAddress,
  customerSiteContact,
  deliveryContact,
  customerProjectContact
}) => {
  const {
    validateSiteName,
    validateSiteAddress,
    validateContact
  } = validateProductFields();

  const [columnSize, setColumnSize] = React.useState(2);

  useResize((size) => {
    if (size === 'xs') {
      setColumnSize(1);
    } else {
      setColumnSize(2);
    }
  }, []);

  const getGroupOfDescs = () => (
    <StaticDataGroup
      config={{ horizontalColumn: columnSize }}
      id="location-details-group-data"
    >
      <StaticData
        id="static-data-test"
        name={ProductSheetLocationDetails.SiteName}
        value={validateSiteName(siteName)}
      />
      <StaticData
        id="static-data-test"
        name={ProductSheetLocationDetails.SiteAddress}
        value={validateSiteAddress(siteRawAddress)}
      />
      {(customerSiteContact.name || customerSiteContact.email) && (
        <StaticData
          id="static-data-test"
          name={ProductSheetLocationDetails.SiteContact}
          value={[customerSiteContact.name, customerSiteContact.email]}
        />
      )}
      {deliveryContact?.name && (
        <StaticData
          id="static-data-test"
          name={ProductSheetLocationDetails.DeliveryContact}
          value={[deliveryContact?.name, deliveryContact?.email]}
        />
      )}
      <StaticData
        id="static-data-test"
        name={ProductSheetLocationDetails.CustomerProjectContact}
        value={validateContact([
          customerProjectContact?.name,
          customerProjectContact?.email,
          customerProjectContact?.contact
        ])}
      />
    </StaticDataGroup>
  );

  return (
    <Spacing top="spacing3x">
      <ProductDetailsSection
        title={ProductSheetLocationDetails.Title}
        descriptionGroup={getGroupOfDescs()}
      />
    </Spacing>
  );
};

export default LocationAndContactDetails;
